module.exports = __webpack_public_path__ + "static/media/youbaoAPPbj.c7b17794.png";